<template>

    <MenuMain/>
    <MenuMsModuleOverview/>
    <HeadingOverviewDashboard/>

    <div class="px-6 surface-overlay relative">
        <div class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h2>Hello {{ this.profile.firstName }}</h2>

                    <br>
                    <h2>What Would You Like to Do Today?</h2>
                    <li @click="processClientMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>Add or view clients?</span>
                    </li>

                    <li @click="processAppointmentMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>Create and manage appointments?</span>
                    </li>

                    <li @click="processInvoicesMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>View and manage invoices?</span>
                    </li>

                    <li @click="processPaymentsMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>View and manage payments?</span>
                    </li>

                    <li @click="processClaimsMenu"
                        class="select-none p-2 font-medium text-base cursor-pointer border-round-lg hover:surface-hover hover:text-primary flex justify-content-between align-items-center">
                                <span class="flex align-items-center"><i
                                    class="pi pi-file mr-2"></i>View and manage health insurance claims?</span>
                    </li>

                </div>

                <div class="grid">
                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            &nbsp;
                        </div>
                    </div>
                </div>

                <h2>Dashboard Information</h2>

                <div class="grid">
                    <div class="col-12 lg:col-4 p-3">

                        <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                            <div class="flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-3xl text-900 font-bold">This Month</span>
                                    <p>&nbsp;</p>
                                    <p class="mt-2 mb-0 text-600 text-xl">Income is
                                        {{ this.formatAmount(this.financialSummary.invoiceSummary) }}</p>
                                    <p class="mt-2 mb-0 text-600 text-xl">Payments are
                                        {{ this.formatAmount(this.financialSummary.paymentSummary) }}</p>
                                </div>
                                <div>
                                    <img src="/images/blocks/illustration/stats-illustration-4.svg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 lg:col-4 p-3">
                        <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                            <div class="flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-3xl text-900 font-bold">Last Month</span>
                                    <p>&nbsp;</p>
                                    <p class="mt-2 mb-0 text-600 text-xl">Income was
                                        {{ this.formatAmount(this.financialSummary.invoiceSummaryPreviousMonth) }}</p>
                                    <p class="mt-2 mb-0 text-600 text-xl">Payments were
                                        {{ this.formatAmount(this.financialSummary.paymentSummaryPreviousMonth) }}</p>
                                </div>
                                <div>
                                    <img src="/images/blocks/illustration/stats-illustration-5.svg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 lg:col-4 p-3">
                        <div class="shadow-2 surface-card p-3" style="border-radius: 12px">
                            <div class="flex align-items-center justify-content-between">
                                <div>
                                    <span class="text-3xl text-900 font-bold">Two Months Ago</span>
                                    <p>&nbsp;</p>
                                    <p class="mt-2 mb-0 text-600 text-xl">Income was
                                        {{ this.formatAmount(this.financialSummary.invoiceSummaryTwoMonthsAgo) }}</p>
                                    <p class="mt-2 mb-0 text-600 text-xl">Payments were
                                        {{ this.formatAmount(this.financialSummary.paymentSummaryTwoMonthsAgo) }}</p>
                                </div>
                                <div>
                                    <img src="/images/blocks/illustration/stats-illustration-6.svg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid">
                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            &nbsp;
                        </div>
                    </div>
                </div>

<!--                <div class="grid">-->
<!--                    <div class="col-12 md:col-6">-->
<!--                        <div class="card p-fluid">-->

<!--                            <h2>Invoice Trend Over Last 6 Months</h2>-->
<!--                            <div>-->
<!--                                <Chart type="bar" :data="barData" :options="barOptions"-->
<!--                                       style="width: 100%; height: 100%;"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-12 md:col-1">-->
<!--                        <div class="card p-fluid">-->
<!--                            &nbsp;-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-12 md:col-3">-->
<!--                        <div class="card p-fluid">-->

<!--                            <h2>Monthly Appointment Overview</h2>-->
<!--                            <div>-->
<!--                                <Chart type="pie" :data="pieData" :options="pieOptions"/>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->


<!--                <div class="grid">-->
<!--                    <div class="col-12 md:col-12">-->
<!--                        <div class="card p-fluid">-->
<!--                            &nbsp;-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->


<!--                <div class="grid">-->
<!--                    <div class="col-12 md:col-6">-->
<!--                        <div class="card p-fluid">-->

<!--                            <h2>Client Trend</h2>-->
<!--                            <div>-->
<!--                                <Chart type="bar" :data="barData" :options="barOptions"-->
<!--                                       style="width: 100%; height: 100%;"/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-12 md:col-1">-->
<!--                        <div class="card p-fluid">-->
<!--                            &nbsp;-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-12 md:col-3">-->
<!--                        <div class="card p-fluid">-->

<!--                            <h2>Appointments for Today</h2>-->
<!--                            <div>-->
<!--                                <ul class="p-0 m-0 list-none">-->
<!--                                    <li v-for="(trail, index) in auditTrails" :key="index"-->
<!--                                        class="flex align-items-center py-2 border-bottom-1 surface-border">-->
<!--                                        <div v-if="trail.mainProcess === 'Invoicing Process'">-->
<!--                                            <Button icon="pi pi-money-bill"-->
<!--                                                    class="p-button-rounded p-button-success m-1"/>-->
<!--                                        </div>-->

<!--                                        <div v-else-if="trail.mainProcess === 'Calendar'">-->
<!--                                            <Button icon="pi pi-calendar" class="p-button-rounded p-button-info m-1"/>-->
<!--                                        </div>-->

<!--                                        <div v-else>-->
<!--                                            <Button icon="pi pi-star" class="p-button-rounded p-button-help m-1"/>-->
<!--                                        </div>-->

<!--                                        <span class="text-900 line-height-3 font-normal">-->
<!--                                            {{ trail.description }}-->
<!--                                        </span>-->

<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->


<!--                <div class="grid">-->
<!--                    <div class="col-12 md:col-12">-->
<!--                        <div class="card p-fluid">-->
<!--                            &nbsp;-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->


<!--                <div class="grid">-->
<!--                    <div class="col-12 md:col-6">-->
<!--                        <div class="card p-fluid">-->

<!--                            <h2>Bookings Awaiting Approval</h2>-->
<!--                            <div>-->
<!--                                <ul class="p-0 m-0 list-none">-->
<!--                                    <li v-for="(trail, index) in auditTrails" :key="index"-->
<!--                                        class="flex align-items-center py-2 border-bottom-1 surface-border">-->
<!--                                        <div v-if="trail.mainProcess === 'Invoicing Process'">-->
<!--                                            <Button icon="pi pi-money-bill"-->
<!--                                                    class="p-button-rounded p-button-success m-1"/>-->
<!--                                        </div>-->

<!--                                        <div v-else-if="trail.mainProcess === 'Calendar'">-->
<!--                                            <Button icon="pi pi-calendar" class="p-button-rounded p-button-info m-1"/>-->
<!--                                        </div>-->

<!--                                        <div v-else>-->
<!--                                            <Button icon="pi pi-star" class="p-button-rounded p-button-help m-1"/>-->
<!--                                        </div>-->

<!--                                        <span class="text-900 line-height-3 font-normal">-->
<!--                                            {{ trail.description }}-->
<!--                                        </span>-->

<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-12 md:col-1">-->
<!--                        <div class="card p-fluid">-->
<!--                            &nbsp;-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="col-12 md:col-3">-->
<!--                        <div class="card p-fluid">-->

<!--                            <h2>Tasks Due Today</h2>-->

<!--                            <div>-->
<!--                                <ul class="p-0 m-0 list-none">-->
<!--                                    <li v-for="(trail, index) in auditTrails" :key="index"-->
<!--                                        class="flex align-items-center py-2 border-bottom-1 surface-border">-->
<!--                                        <div v-if="trail.mainProcess === 'Invoicing Process'">-->
<!--                                            <Button icon="pi pi-money-bill"-->
<!--                                                    class="p-button-rounded p-button-success m-1"/>-->
<!--                                        </div>-->

<!--                                        <div v-else-if="trail.mainProcess === 'Calendar'">-->
<!--                                            <Button icon="pi pi-calendar" class="p-button-rounded p-button-info m-1"/>-->
<!--                                        </div>-->

<!--                                        <div v-else>-->
<!--                                            <Button icon="pi pi-star" class="p-button-rounded p-button-help m-1"/>-->
<!--                                        </div>-->

<!--                                        <span class="text-900 line-height-3 font-normal">-->
<!--                                            {{ trail.description }}-->
<!--                                        </span>-->

<!--                                    </li>-->
<!--                                </ul>-->
<!--                            </div>-->

<!--                        </div>-->
<!--                    </div>-->

<!--                </div>-->


<!--                <div class="grid">-->
<!--                    <div class="col-12 md:col-12">-->
<!--                        <div class="card p-fluid">-->
<!--                            &nbsp;-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->


                <div class="grid">
                    <div class="col-12">
                        <div class="card">
                            <h2>Recent Audit Trail Events</h2>

                            <div>
                                <ul class="p-0 m-0 list-none">
                                    <li v-for="(trail, index) in auditTrails" :key="index"
                                        class="flex align-items-center py-2 border-bottom-1 surface-border">
                                        <div v-if="trail.mainProcess === 'Invoicing Process'">
                                            <Button icon="pi pi-money-bill"
                                                    class="p-button-rounded p-button-success m-1"/>
                                        </div>

                                        <div v-else-if="trail.mainProcess === 'Calendar'">
                                            <Button icon="pi pi-calendar" class="p-button-rounded p-button-info m-1"/>
                                        </div>

                                        <div v-else>
                                            <Button icon="pi pi-star" class="p-button-rounded p-button-help m-1"/>
                                        </div>

                                        <span class="text-900 line-height-3 font-normal">
                                            {{ trail.description }}
                                        </span>

                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuMain from "@/components/menu/common/MenuMain.vue";
import MenuMsModuleOverview from "@/components/menu/msmodule/MenuMsModuleOverview.vue";
import HeadingOverviewDashboard from "@/components/heading/common/HeadingOverviewHome.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import numeral from "numeral";
import DashboardService from "@/service/DashboardService";
import AuditTrailService from "@/service/AuditTrailService";
// import Chart from "primevue/chart";
// import Chart from 'primevue/chart';

export default {
    components: {
        MenuMain, MenuMsModuleOverview,
        IsoEvolveFooter, HeadingOverviewDashboard
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    async mounted() {
        try {
            const userPingResponse = await UserService.getUserPing();
            console.log("[PmOverviewDashboard][mounted] System is active.");
            console.log("[PmOverviewDashboard][mounted] Data = ", userPingResponse);
        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] System is NOT active.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            console.log("[PmOverviewDashboard][mounted] User is NOT defined.");
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        try {
            if (!this.userStore.user) {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            }

            this.profile = this.userStore.user;

            try {
                const [financialSummaryData, auditTrailsData] = await Promise.all([
                    DashboardService.getFinancialSummaryOverThreeMonthsForCompany(this.profile.companyId),
                    AuditTrailService.getCompanyAuditTrailsLastTwenty(this.profile.companyId)
                ]);

                this.financialSummary = financialSummaryData.data;
                this.auditTrails = auditTrailsData.data;

                this.loading = false;

            } catch (e) {
                console.error("[PhoneCalls][mounted] Error fetching additional data = ", e);
            }

        } catch (e) {
            console.log("[PmOverviewDashboard][mounted] No user data found.");
            console.log("[PmOverviewDashboard][mounted] Error = ", e);
            this.userStore.clearUser();
            this.$router.push('login');
        }

        // const documentStyle = getComputedStyle(document.body);
        // const textColor = documentStyle.getPropertyValue('--p-text-color');
        // const textColorSecondary = documentStyle.getPropertyValue('--p-text-color-secondary');
        // const surfaceBorder = documentStyle.getPropertyValue('--p-surface-border');

        this.barData = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June'],
            datasets: [
                {
                    label: 'Total',
                    backgroundColor: '#6969F2FF',
                    borderColor: '#9F9FE0FF',
                    data: [65, 59, 80, 81, 56, 55]
                },
                {
                    label: 'Invoiced',
                    backgroundColor: '#FFA500FF',
                    borderColor: '#E7C891FF',
                    data: [28, 48, 40, 19, 86, 27]
                },
                {
                    label: 'Paid',
                    backgroundColor: '#008000FF',
                    borderColor: '#AEECAEFF',
                    data: [18, 38, 30, 9, 76, 17]
                }
            ]
        };

        this.barOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: '#42A5F5'
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: '#42A5F5',
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: '#42A5F5'
                    },
                    grid: {
                        color: '#42A5F5',
                        drawBorder: false
                    }
                }
            }
        };

        this.pieData = {
            labels: ['Scheduled', 'Completed', 'Missed', 'Invoiced', 'Paid', 'Personal', 'Booking'],

            datasets: [
                {
                    data: [540, 325, 702, 602, 70, 209, 405],
                    backgroundColor: ['#6969f2', '#800080FF', '#FF0000FF', '#FFA500FF',
                        '#008000FF', '#A42BEAFF', '#74E3C5FF'],
                    hoverBackgroundColor: ['#9F9FE0FF', '#EAA2EAFF', '#E49494FF', '#E7C891FF',
                        '#AEECAEFF', '#D4ABECFF', '#BBECDFFF']
                }
            ]
        };

        this.pieOptions = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: '#42A5F5'
                    }
                }
            }
        };
    },
    data() {

        return {
            profile: {},
            financialSummary: {},
            auditTrails: null,
            barData: null,
            barOptions: null,
            pieData: null,
            pieOptions: null
        }
    },
    methods: {
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return 0;
            }
        },
        processClientMenu() {
            this.$router.push("commonClients");
        },
        processAppointmentMenu() {
            this.$router.push("commonAppointments");
        },
        processPaymentsMenu() {
            this.$router.push("commonFinancialPayments");
        },
        processInvoicesMenu() {
            this.$router.push("commonFinancialInvoices");
        },
        processClaimsMenu() {
            this.$router.push("healthFinancialClaims");
        }
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}
</style>
